"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorrowerEntitySchema = exports.BorrowerItemSchema = exports.BackupServicerEntitySchema = exports.BackupServicerItemSchema = exports.AdminAgentEntitySchema = exports.AdminAgentItemSchema = exports.BasePartyEntitySchema = exports.InterestRateBase = exports.InterestRateBaseIterable = exports.CustomerType = exports.CustomerTypeIterable = exports.PartyType = exports.PartyTypeIterable = void 0;
// Items namespace converted to module
const z = __importStar(require("zod"));
// Specific import to avoid circular dependency:
// DbTables.ts imports CreditAgreement which includes DomainEntity.Items
const DbTables_1 = require("../../DbTables");
const Organization = __importStar(require("../../Organization"));
const DomainEntity_1 = require("./DomainEntity");
exports.PartyTypeIterable = [
    'adminAgent',
    'backupServicer',
    'borrower',
    'capitalProvider',
    'capitalProviderRepresentative',
    'collectionAccountBank',
    'payingAgent',
    'servicer',
    'verificationAgent',
];
exports.PartyType = {
    AdminAgent: 'adminAgent',
    BackupServicer: 'backupServicer',
    Borrower: 'borrower',
    CapitalProvider: 'capitalProvider',
    CapitalProviderRepresentative: 'capitalProviderRepresentative',
    CollectionAccountBank: 'collectionAccountBank',
    PayingAgent: 'payingAgent',
    Servicer: 'servicer',
    VerificationAgent: 'verificationAgent',
};
exports.CustomerTypeIterable = ['owner', 'limited', 'none'];
exports.CustomerType = {
    /**
     * The customer on whose behalf we have configured this facility. Most commonly this will be
     * a borrower using Finley to generate loan tapes, compute a borrowing base report, and submit
     * funding requests; or a capital provider set up for calc verification.
     *
     * This customer has the broadest set of permissions on a facility.
     */
    Owner: 'owner',
    /**
     * A customer who is not an {@link Owner}, but may log in to Finley's systems. Examples: a
     * capital provider who logs in to approve o borrower Owner's funding request; or a borrower
     * who logs in to do remediation on a capital provider Owner's verification facility.
     *
     * The set of permissions allowed here is currently poorly defined, but this will become more
     * explicit over time.
     */
    Limited: 'limited',
    /**
     * This party exists in the system for record-keeping, but does not log in to or interact with
     * our system directly.
     */
    None: 'none',
};
exports.InterestRateBaseIterable = ['fixed', 'benchmark'];
exports.InterestRateBase = {
    Fixed: 'fixed',
    Benchmark: 'benchmark',
};
const CapitalProviderConfigSchema = z.object({
    interestRateBase: z.enum(exports.InterestRateBaseIterable),
});
const BaseItemSchema = z.object({
    _id_: z.string(),
    section: z.optional(z.string().nullable()),
    _isWrittenIn_: z.boolean(),
});
const UserSchema = z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});
const BaseEntitySchema = z.object({
    entity: z.union([
        UserSchema,
        Organization.BaseOrganizationSchema,
        DbTables_1.BankAccountWithInstitutionSchema,
    ]),
    section: z.optional(z.string().nullable()),
    _isWrittenIn_: z.boolean(),
});
const UserItemSchema = BaseItemSchema.extend({
    primaryContact: DomainEntity_1.BooleanPropertySchema,
    _isWrittenIn_: z.boolean(),
});
const UserEntitySchema = BaseEntitySchema.extend({
    entity: UserSchema,
    primaryContact: DomainEntity_1.BooleanPropertySchema,
});
const BankAccountItemSchema = BaseItemSchema.extend({
    type: DomainEntity_1.BankAccountTypeSchema,
    cashAdvanceRate: z.optional(DomainEntity_1.CashAdvanceRatePropertySchema),
});
const BankAccountEntitySchema = BaseEntitySchema.extend({
    entity: DbTables_1.BankAccountWithInstitutionSchema,
    type: DomainEntity_1.BankAccountTypeSchema,
    cashAdvanceRate: z.optional(DomainEntity_1.CashAdvanceRatePropertySchema),
});
const BaseOrganizationEntitySchema = BaseEntitySchema.extend({
    entity: Organization.BaseOrganizationSchema,
});
const BasePartyItemSchema = BaseItemSchema.extend({
    type: z.enum(exports.PartyType),
    customerType: z.enum(exports.CustomerType),
    users: UserItemSchema.array(),
});
exports.BasePartyEntitySchema = BaseOrganizationEntitySchema.extend({
    type: z.enum(exports.PartyType),
    customerType: z.enum(exports.CustomerType),
    users: UserEntitySchema.array(),
});
exports.AdminAgentItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.AdminAgent),
    customerType: z.literal(exports.CustomerType.None),
    feeDescription: z.optional(DomainEntity_1.TextPropertySchema),
});
exports.AdminAgentEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.AdminAgent),
    customerType: z.literal(exports.CustomerType.None),
    feeDescription: z.optional(DomainEntity_1.TextPropertySchema),
});
exports.BackupServicerItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.BackupServicer),
    customerType: z.literal(exports.CustomerType.None),
});
exports.BackupServicerEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.BackupServicer),
    customerType: z.literal(exports.CustomerType.None),
});
exports.BorrowerItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.Borrower),
    customerType: z.enum(exports.CustomerType),
    borrowerEntityName: DomainEntity_1.TextPropertySchema,
    bankAccounts: BankAccountItemSchema.array(),
});
exports.BorrowerEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.Borrower),
    customerType: z.enum(exports.CustomerType),
    borrowerEntityName: DomainEntity_1.TextPropertySchema,
    bankAccounts: BankAccountEntitySchema.array(),
});
const CapitalProviderRepresentativeItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.CapitalProviderRepresentative),
    customerType: z.literal(exports.CustomerType.None),
});
const CollectionAccountBankItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.CollectionAccountBank),
    customerType: z.literal(exports.CustomerType.None),
});
const CollectionAccountBankEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.CollectionAccountBank),
    customerType: z.literal(exports.CustomerType.None),
});
const PayingAgentItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.PayingAgent),
    customerType: z.literal(exports.CustomerType.None),
});
const PayingAgentEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.PayingAgent),
    customerType: z.literal(exports.CustomerType.None),
});
const ServicerItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.Servicer),
    customerType: z.literal(exports.CustomerType.None),
    feeDescription: z.optional(DomainEntity_1.TextPropertySchema),
    feePaymentDateDescription: z.optional(DomainEntity_1.TextPropertySchema),
});
const ServicerEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.Servicer),
    customerType: z.literal(exports.CustomerType.None),
    feeDescription: z.optional(DomainEntity_1.TextPropertySchema),
    feePaymentDateDescription: z.optional(DomainEntity_1.TextPropertySchema),
});
const VerificationAgentItemSchema = BasePartyItemSchema.extend({
    type: z.literal(exports.PartyType.VerificationAgent),
    customerType: z.literal(exports.CustomerType.None),
});
const VerificationAgentEntitySchema = exports.BasePartyEntitySchema.extend({
    type: z.literal(exports.PartyType.VerificationAgent),
    customerType: z.literal(exports.CustomerType.None),
});
//# sourceMappingURL=Items.js.map